import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { Suspense } from "react";

const KeyboardShortcutsSideEffects = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "HeaderKeyboardShortcuts" */ "./KeyboardShortcutsSideEffects"
  ).then(module => ({ default: module.KeyboardShortcutsSideEffects })),
);

/** Lazy boundary so it doesn't load on initial page load. */
export const LazyKeyboardShortcutsSideEffects = () => (
  <Suspense fallback={null}>
    <KeyboardShortcutsSideEffects />
  </Suspense>
);
